'use client';

import * as React from 'react';
import styles from './Textarea.module.css';
import clsx from 'clsx';

export interface TextareaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  label?: string;
  helperText?: string;
  error?: string;
  required?: boolean;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
  onChange?: (value: string) => void;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      helperText,
      error,
      required = false,
      resize = 'vertical',
      disabled = false,
      className,
      style,
      onChange,
      ...props
    },
    ref
  ) => {
    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e.target.value);
    };

    return (
      <div className={clsx(styles.container, className)}>
        {label && (
          <label className={styles.label}>
            {label}
            {required && <span className={styles.required}>*</span>}
          </label>
        )}
        <textarea
          ref={ref}
          className={clsx(styles.textarea, error && styles.error)}
          disabled={disabled}
          onChange={handleChange}
          {...props}
          // Merge rather than let a caller's `style` replace this object —
          // dropping `resize` falls back to the browser default of `both`.
          style={{ ...style, resize }}
        />
        {helperText && !error && <span className={styles.helperText}>{helperText}</span>}
        {error && <span className={styles.errorText}>{error}</span>}
      </div>
    );
  }
);

Textarea.displayName = 'Textarea';
